import { useContext, useEffect, useState } from "react";
import UserContext from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import Select from "react-select";
import { textes } from "../constants/textes";
import { config } from "../constants/config";
import PackBasic from "./packbasic";
import PackClassic from "./packclassic";
import PackExt from "./packext";
import PackExtPlus from "./packextplus";


export default function Home() {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [fetching, setFetching] = useState(false);
    const [email, setEmail] = useState("");
    const [noms, setnoms] = useState("");
    const [subject, setsubject] = useState("");
    const [message, setmessage] = useState("");

    const [page, setPage] = useState(0);

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const displayPages = () => {
        if (page === 0) {
            return <PackBasic />;
        } else if (page === 1) {
            return <PackClassic />;
        } else if (page === 2) {
            return <PackExt />;
        } else {
            return <PackExtPlus />;
        }
    }

    function isElementInViewport(el) {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function handleScroll() {
        // Sélectionnez tous les blocs que vous souhaitez vérifier
        const blocks = document.querySelectorAll('[class]');

        blocks.forEach(block => {
            if (isElementInViewport(block)) {

                // console.log("Le bloc avec est visible", block.id);
                // console.log("Le bloc avec est visible", block.className);
                if (block.id === "hero") {
                    console.log("hero true");
                } else if (block.id === "about") {
                    console.log("about true");
                } else if (block.id === "pricing") {
                    console.log("pricing true");
                } else if (block.id === "features") {
                    console.log("features true");
                } else if (block.id === "contact") {
                    console.log("contact true");
                }

            }
        });
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('load', handleScroll);



    // comportement
    const getstarted = () => {
        navigate("/login");
    }

    useEffect(() => {

    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        setFetching(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.api.PUBLICKEY);
        // myHeaders.append("apikey", user.token);
        // myHeaders.append("cpte", user.code);
        // myHeaders.append("prof", user.profil);
        // myHeaders.append("conn", user.espace);

        var urlencoded = new URLSearchParams();
        if (email) urlencoded.append("from", email);
        urlencoded.append("to", config.mailfrom);
        if (subject) urlencoded.append("subject", subject);
        if (message) urlencoded.append("text", noms + "\n" + message);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.api.BASE_URL}/${config.api.PROJECT}/mails`, requestOptions).then((response) => {
            if (response?.status === 200 || response?.status === 201) {
                response.json().then(async (data) => {
                    // console.log("resonse ajout droit", data);
                    if (!data?.head) {
                        setFetching(false);
                        showErrorMessage(data?.body?.data?.msg);
                    } else {
                        showSuccesMessage("Message envoyé");
                        setnoms("");
                        setEmail("");
                        setmessage("");
                        setsubject("");
                        setFetching(false);
                    }

                });
            } else {
                showErrorMessage(textes.fr.serviceunavaillable);
                setFetching(false);
            }
        }).catch((err) => {
            showErrorMessage(textes.fr.serviceunavaillable);
            setFetching(false);
        });
    }

    // affichage
    return (
        <>
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between" style={{ marginBottom: "4px" }}>

                    <a href="/" className="logo d-flex align-items-center me-auto me-xl-0">
                        {/* <!-- Uncomment the line below if you also wish to use an image logo -->
                    <!-- <img src="/assets/imgs/logo.png" alt=""> --> */}
                        <h1 className="sitename">YConnekt</h1>
                    </a>

                    <nav id="navmenu" className="navmenu">
                        <ul>
                            <li><a href="#hero" className="active">Accueil</a></li>
                            <li><a href="#about">A Propos</a></li>
                            {/* <li><a href="#features">Fonctionnalités</a></li> */}
                            {/* <li><a href="#services">Services</a></li> */}
                            <li><a href="#pricing">Abonnements</a></li>
                            <li><a href="#features">Kits</a></li>
                            {/* <li className="dropdown"><a href="#"><span>Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                            <ul>
                                <li><a href="#">Dropdown 1</a></li>
                                <li className="dropdown"><a href="#"><span>Deep Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                                    <ul>
                                        <li><a href="#">Deep Dropdown 1</a></li>
                                        <li><a href="#">Deep Dropdown 2</a></li>
                                        <li><a href="#">Deep Dropdown 3</a></li>
                                        <li><a href="#">Deep Dropdown 4</a></li>
                                        <li><a href="#">Deep Dropdown 5</a></li>
                                    </ul>
                                </li>
                                <li><a href="#">Dropdown 2</a></li>
                                <li><a href="#">Dropdown 3</a></li>
                                <li><a href="#">Dropdown 4</a></li>
                            </ul>
                        </li> */}
                            <li><a href="#contact">Contact</a></li>
                        </ul>
                        <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
                    </nav>

                    <button className="btn-getstarted btn" onClick={getstarted}>{textes.fr.starttexte}</button>

                </div>
            </header>

            <main className="main">
                {/* home */}
                <section id="hero" name="hero" className="hero hero22 section">

                    <div className="container" data-aos="fade-up" data-aos-delay="100">

                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="hero-content" data-aos="fade-up" data-aos-delay="200">
                                    {/* <div className="company-badge mb-4">
                                        <i className="bi bi-wifi me-2 mr-3"></i>
                                        Bienvenu sur le réseau
                                    </div> */}

                                    <h1 className="mb-4">{textes.fr.titre1home}
                                        <span className="accent-text"> {textes.fr.homename}</span>
                                    </h1>

                                    <p className="mb-2 mb-md-3" style={{ textAlign: "justify" }}>{textes.fr.soustitre1home}</p>
                                    <p className="mb-4 mb-md-5" style={{ textAlign: "justify" }}>{textes.fr.soustitre2home}</p>

                                    <div className="hero-buttons">
                                        <button className="btn btn-primary me-0 me-sm-2 mx-1" onClick={getstarted}>{textes.fr.starttexte}</button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="hero-image" data-aos="zoom-out" data-aos-delay="300">
                                    <img src="/assets/imgs/bg_login2.png" alt="Hero IMG" className="img-fluid" />
                                    {/* <img src="/assets/imgs/home.png" alt="Hero IMG" className="img-fluid" /> */}
                                    {/* <img src="/assets/imgs/illustration-1.webp" alt="Hero IMG" className="img-fluid" /> */}

                                    <div className="customers-badge">
                                        <div className="customer-avatars" style={{ justifyContent: "center" }}>
                                            <img src="/assets/imgs/wifi.png" alt="Customer 1" className="avatar" />
                                            {/* <img src="/assets/imgs/avatar-2.webp" alt="Customer 2" className="avatar" />
                                            <img src="/assets/imgs/avatar-3.webp" alt="Customer 3" className="avatar" />
                                            <img src="/assets/imgs/avatar-4.webp" alt="Customer 4" className="avatar" />
                                            <img src="/assets/imgs/avatar-5.webp" alt="Customer 5" className="avatar" />
                                            <span className="avatar more">12+</span> */}
                                        </div>
                                        <p className="mb-0 mt-2">{textes.fr.slogant}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="row stats-row gy-4 mt-5" data-aos="fade-up" data-aos-delay="500">
                            <div className="col-lg-3 col-md-6">
                                <div className="stat-item">
                                    <div className="stat-icon">
                                        <i className="bi bi-trophy"></i>
                                    </div>
                                    <div className="stat-content">
                                        <h4>3x Won Awards</h4>
                                        <p className="mb-0">Vestibulum ante ipsum</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="stat-item">
                                    <div className="stat-icon">
                                        <i className="bi bi-briefcase"></i>
                                    </div>
                                    <div className="stat-content">
                                        <h4>6.5k Faucibus</h4>
                                        <p className="mb-0">Nullam quis ante</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="stat-item">
                                    <div className="stat-icon">
                                        <i className="bi bi-graph-up"></i>
                                    </div>
                                    <div className="stat-content">
                                        <h4>80k Mauris</h4>
                                        <p className="mb-0">Etiam sit amet orci</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="stat-item">
                                    <div className="stat-icon">
                                        <i className="bi bi-award"></i>
                                    </div>
                                    <div className="stat-content">
                                        <h4>6x Phasellus</h4>
                                        <p className="mb-0">Vestibulum ante ipsum</p>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                    </div>

                </section>

                {/* about */}
                <section id="about" name="about" className="about about22 section">

                    <div className="container" data-aos="fade-up" data-aos-delay="100">

                        <div className="row gy-4 align-items-center justify-content-between">

                            <div className="col-xl-5" data-aos="fade-up" data-aos-delay="200">
                                <span className="about-meta">{textes.fr.titreaboutus}</span>
                                {/* <h2 className="about-title">Voluptas enim suscipit temporibus</h2> */}
                                <p className="about-description mb-1" style={{ textAlign: "justify" }}>{textes.fr.aboutdesc}</p>
                                <p className="about-description" style={{ textAlign: "justify" }}>{textes.fr.aboutdesc2}</p>

                                <div className="row feature-list-wrapper">
                                    <div className="col-md-12">
                                        <ul className="feature-list">
                                            <li><i className="bi bi-check-circle-fill"></i> Abonnement annuel à la plateforme : 50.000 FCFA</li>
                                            <li><i className="bi bi-check-circle-fill"></i> Accès au système de gestion et support technique 24/7</li>
                                            <li><i className="bi bi-check-circle-fill"></i> Prélèvement réduit : seulement 5% sur les retraits d'argent générés par votre réseau</li>
                                        </ul>
                                    </div>
                                    <div className="col-md-12">
                                        <ul className="feature-list">
                                            <li><i className="bi bi-check-circle-fill"></i> Equipement scalable : mise à niveau possible des packs pour étendre la couverture</li>
                                            <li><i className="bi bi-check-circle-fill"></i> Surveiller le Traffic dans votre réseau à distance</li>
                                            <li><i className="bi bi-check-circle-fill"></i> Définir les couts des forfaits internet à vendre</li>
                                            <li><i className="bi bi-check-circle-fill"></i> Voir les gains en temps réel</li>
                                        </ul>
                                    </div>
                                </div>

                                {/* <div className="info-wrapper">
                                    <div className="row gy-4">
                                        <div className="col-lg-5">
                                            <div className="profile d-flex align-items-center gap-3">
                                                <img src="/assets/imgs/avatar-1.webp" alt="CEO Profile" className="profile-image" />
                                                <div>
                                                    <h4 className="profile-name">Mario Smith</h4>
                                                    <p className="profile-position">CEO &amp; Founder</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-7">
                                            <div className="contact-info d-flex align-items-center gap-2">
                                                <i className="bi bi-telephone-fill"></i>
                                                <div>
                                                    <p className="contact-label">Call us anytime</p>
                                                    <p className="contact-number">+123 456-789</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>

                            <div className="col-xl-6" data-aos="fade-up" data-aos-delay="300">
                                <div className="image-wrapper">
                                    <div className="images position-relative" data-aos="zoom-out" data-aos-delay="400">
                                        <img src="/assets/imgs/about.jpg" alt="Business Meeting" className="img-fluid main-image rounded-4" />
                                        <img src="/assets/imgs/baie.jpg" alt="Team Discussion" className="img-fluid small-image rounded-4" />
                                        <img src="/assets/imgs/starlinck.jpg" alt="Team Discussion" className="img-fluid small-image rounded-4" style={{ marginTop: "300px" }} />
                                    </div>
                                    <div className="experience-badge floating">
                                        <h3>8+ <span>Années d'expérience </span></h3>
                                        <p>Dans le réseau wifi et interconnexion VPN</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </section>

                {/* pricins */}
                <section id="pricing" className="pricing pricing22 section light-background">

                    {/* <!-- Section Title --> */}
                    <div className="container section-title" data-aos="fade-up">
                        <h2>Abonnements</h2>
                        <p>💡 Nos principaux abonnement disponible. Investissez aujourd’hui, récoltez demain</p>
                    </div>
                    {/* <!-- End Section Title --> */}

                    <div className="container" data-aos="fade-up" data-aos-delay="100">

                        <div className="row g-4 justify-content-center">

                            {/* <!-- Basic Plan --> */}
                            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                                <div className="pricing-card">
                                    <h3>Abonnement VPN</h3>
                                    <div className="price">
                                        <span className="currency">XAF</span>
                                        <span className="amount">30.000</span>
                                        <span className="period">/ an</span>
                                    </div>
                                    <p className="description">Abonnement destiné au contrôle vos sites à distance en un clic, réaliser une interconnexion entre vos agences grâce à notre tu nel virtuel.</p>

                                    <h4>Différentes options:</h4>
                                    <ul className="features-list">
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            Accès distants router
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            Excepteur sint occaecat
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            Interconnexion sites distants (sur devis)
                                        </li>
                                    </ul>

                                    {/* <a href="#" className="btn btn-primary">
                                        Buy Now
                                        <i className="bi bi-arrow-right"></i>
                                    </a> */}
                                </div>
                            </div>

                            {/* <!-- Standard Plan --> */}
                            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                                <div className="pricing-card popular">
                                    <div className="popular-badge">Principal</div>
                                    <h3>Abonnement partenaire</h3>
                                    <div className="price">
                                        <span className="currency">XAF</span>
                                        <span className="amount">50.000</span>
                                        <span className="period">/ ans</span>
                                    </div>
                                    <p className="description">Abonnement destiné aux partenaires qui souhaitent accéder à la plateforme YCONNEKT et bénéficier de divers outils et services pour gérer leur réseau.</p>

                                    <h4>Différentes options:</h4>
                                    <ul className="features-list">
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            Accès à la plateforme de gestion
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            Support technique 24/7
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            Demande de mise à jour des kits
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            Seulement 8% de commission prélévé sur les revenus générés par votre réseau
                                        </li>
                                    </ul>

                                    {/* <a href="#" className="btn btn-light">
                                        Buy Now
                                        <i className="bi bi-arrow-right"></i>
                                    </a> */}
                                </div>
                            </div>

                            {/* <!-- Premium Plan --> */}
                            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="300">
                                <div className="pricing-card">
                                    <h3>Abonnement publicitaire</h3>
                                    {/* <div className="price">
                                        <span className="currency">XAF</span>
                                        <span className="amount">30.000</span>
                                        <span className="period">/ mois</span>
                                    </div> */}
                                    <p className="description">Vous pouvez également diffuser de la publicité sur le portail captif YCONNEKT pour générer des revenus supplémentaires.</p>

                                    <h4>Différentes options:</h4>
                                    <ul className="features-list">
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            500 FCFA / visibilité 1 jour
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            3000 FCFA / visibilité de 7 jours
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            5000 FCFA / visibilité de 14 jours
                                        </li>
                                        <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            12 500 FCFA / visibilité de 30 jours
                                        </li>
                                        {/* <li>
                                            <i className="bi bi-check-circle-fill"></i>
                                            Maxime placeat facere possimus
                                        </li> */}
                                    </ul>

                                    {/* <a href="#" className="btn btn-primary">
                                        Buy Now
                                        <i className="bi bi-arrow-right"></i>
                                    </a> */}
                                </div>
                            </div>

                        </div>

                    </div>

                </section>

                {/* stats */}
                {/* <section id="stats" className="stats section">

                    <div className="container" data-aos="fade-up" data-aos-delay="100">

                        <div className="row gy-4">

                            <div className="col-lg-3 col-md-6">
                                <div className="stats-item text-center w-100 h-100">
                                    <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter">52</span>
                                    <p>Clients</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                                <div className="stats-item text-center w-100 h-100">
                                    <span data-purecounter-start="0" data-purecounter-end="521" data-purecounter-duration="1" className="purecounter">500</span>
                                    <p>Projects</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                                <div className="stats-item text-center w-100 h-100">
                                    <span data-purecounter-start="0" data-purecounter-end="1453" data-purecounter-duration="1" className="purecounter">65</span>
                                    <p>Hours Of Support</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                                <div className="stats-item text-center w-100 h-100">
                                    <span data-purecounter-start="0" data-purecounter-end="32" data-purecounter-duration="1" className="purecounter">1552</span>
                                    <p>Workers</p>
                                </div>
                            </div>

                        </div>

                    </div>

                </section> */}

                {/* packs */}
                <section id="features" className="features features22 section">

                    <div className="container section-title" data-aos="fade-up">
                        <h2>KITS</h2>
                        <p>✨ Devenez partenaire d’un réseau panafricain et transformez votre zone stratégique en source de revenus durables</p>
                    </div>

                    <div className="container">

                        <div className="d-flex justify-content-center">

                            <ul className="nav nav-tabs" data-aos="fade-up active show" data-aos-delay="100">

                                <li className="nav-item">
                                    <button className={`nav-link ${page === 0 ? " active show" : ""}`} onClick={() => { setPage(0) }} >
                                        <h4>KIT_YCONNEKT-BASIC</h4>
                                    </button>
                                </li>
                                {/*<li className="nav-item">
                                    <button className={`nav-link ${page === 1 ? " active show" : ""}`} onClick={() => { setPage(1) }} >
                                        <h4>KIT_YCONNEKT-CLASSIC</h4>
                                    </button>
                                </li>*/}
                                <li className="nav-item">
                                    <button className={`nav-link ${page === 2 ? " active show" : ""}`} onClick={() => { setPage(2) }} >
                                        <h4>KIT_YCONNEKT-EXT</h4>
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className={`nav-link ${page === 3 ? " active show" : ""}`} onClick={() => { setPage(3) }} >
                                        <h4>KIT_YCONNEKT-EXT+</h4>
                                    </button>
                                </li>

                            </ul>

                        </div>

                        <div className="tab-content" data-aos="fade-up" data-aos-delay="200">

                            {displayPages()}

                        </div>

                    </div>

                </section>


                {/* contact */}
                <section id="contact" className="contact contact22 section light-background">

                    {/* <!-- Section Title --> */}
                    <div className="container section-title" data-aos="fade-up">
                        <h2>Contact</h2>
                        <p>🚀 Transformez votre réseau en machine à revenus avec Yconnekt !
                            Que vous soyez un café, un hôtel, un campus ou un quartier animé, nos KIT_YCONNEKT sont conçus pour attirer plus d’utilisateurs, fidéliser vos clients et générer des revenus stables.
                        </p>
                    </div>
                    {/* <!-- End Section Title --> */}

                    <div className="container" data-aos="fade-up" data-aos-delay="100">

                        <div className="row g-4 g-lg-5">
                            <div className="col-lg-5">
                                <div className="info-box" data-aos="fade-up" data-aos-delay="200">
                                    <h3>Nos Informations</h3>
                                    <p>{textes.fr.slogant}</p>

                                    <div className="info-item" data-aos="fade-up" data-aos-delay="300">
                                        <div className="icon-box">
                                            <i className="bi bi-geo-alt"></i>
                                        </div>
                                        <div className="content">
                                            <h4>Notre Localisation</h4>
                                            <p>Yaoundé</p>
                                            <p>Carrefour ceper elig essono</p>
                                        </div>
                                    </div>

                                    <div className="info-item" data-aos="fade-up" data-aos-delay="400">
                                        <div className="icon-box">
                                            <i className="bi bi-telephone"></i>
                                        </div>
                                        <div className="content">
                                            <h4>Numéros de téléphone</h4>
                                            <p>+237 656324538</p>
                                            <p>+237 696827712</p>
                                            <p>+237 655597230</p>
                                        </div>
                                    </div>

                                    <div className="info-item" data-aos="fade-up" data-aos-delay="500">
                                        <div className="icon-box">
                                            <i className="bi bi-envelope"></i>
                                        </div>
                                        <div className="content">
                                            <h4>Adresse Email</h4>
                                            <p>service@yconnekt.com</p>
                                            {/* <p>contact@example.com</p> */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-7">
                                <div className="contact-form" data-aos="fade-up" data-aos-delay="300">
                                    <h3>Nous Contacter</h3>
                                    <p>Votre communauté a besoin de vous : Offrez un internet vital pour l’éducation, le travail et le divertissement.</p>

                                    <form onSubmit={handleSubmit} className="" data-aos="fade-up" data-aos-delay="200">
                                        <div className="row gy-4">

                                            <div className="col-md-6 mb-3">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control"
                                                    placeholder="Noms et prénoms"
                                                    required
                                                    value={noms}
                                                    onChange={(e) => setnoms(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-6 mb-3 ">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="email"
                                                    placeholder="Adresse email"
                                                    required
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-12 mb-3">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="subject"
                                                    placeholder="Sujet"
                                                    required
                                                    value={subject}
                                                    onChange={(e) => setsubject(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-12 mb-3">
                                                <textarea
                                                    className="form-control"
                                                    name="message"
                                                    rows="6"
                                                    placeholder="Message"
                                                    required
                                                    value={message}
                                                    onChange={(e) => setmessage(e.target.value)}
                                                ></textarea>
                                            </div>

                                            <div className="col-12 text-center">
                                                <button type="submit" className="btn"
                                                    disabled={noms && email && subject && message ? false : true}
                                                >Send Message  {fetching && <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                />}
                                                </button>
                                            </div>

                                        </div>
                                    </form>

                                </div>
                            </div>

                        </div>

                    </div>

                </section>
                <ToastContainer />

            </main>

            {/* footer */}
            <footer id="footer" className="footer">
                <div className="container copyright text-center mt-4">
                    <p>© <span>Copyright</span> <strong className="px-1 sitename">YConnekt</strong> <span>All Rights Reserved</span></p>
                    <div className="credits">
                        designed and developed by <a style={{pointerEvents: "none"}} target="_blank"  rel="noreferrer" href="https://facebook.com/people/We-love-computer/100063601807719/?mibextid=ZbWKwL">WLC</a>
                    </div>
                </div>
            </footer>


            {/* <a href="#" id="scroll-top" className="scroll-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short"></i></a> */}
        </>
    );
}